import React from 'react';
import './visualize.css';
import "react-responsive-carousel/lib/styles/carousel.min.css"; // requires a loader
import { Carousel } from 'react-responsive-carousel'

function visualize(props) {
    const english = props.english
    const spanish = props.spanish

    return (
        
        <div id='visualize-container'>
            <div id='visualize-left'></div>
            <div id='carousel-container'>
            {/* <div id='visualize-me-header'>Visualize Me</div> */}
            
            {english && (<div id='visualize-me-header'>Visualize Me</div>)}
            {spanish && (<div id='visualize-me-header'>Visualízame</div>)}

            <Carousel showThumbs={false} autoPlay 
            // dynamicHeight={true}
            >
                
                <div>
                    <img class='portrait' alt="" src="https://i.ibb.co/mqj6728/mail.jpg" />
                </div>
                <div>
                    <img class='portrait' alt="" src="https://i.ibb.co/c3F3M7q/IMG-3550.jpg" />
                </div>
                <div>
                    <img class='landscape' alt="" src="https://i.ibb.co/R4jL4Mq/IMG-3528.jpg" />
                </div>
                
                <div>
                    <img class='landscape' alt="" src="https://i.ibb.co/vhg1WmD/IMG-3571.jpg" />
                </div>
                <div>
                    <img class='portrait' alt="" src="https://i.ibb.co/RckFbpq/IMG-3563.jpg" />
                </div>
                <div>
                    <img class='portrait' alt="" src="https://i.ibb.co/CV0qMc8/mail-3.jpg" />
                </div>
                <div>
                    <img class='portrait' alt="" src="https://i.ibb.co/yNQtJfq/IMG-3480.jpg" />
                </div>
                <div>
                    <img class='portrait' alt="" src="https://i.ibb.co/8KqvLPs/mail-2.jpg" />
                </div>
                <div>
                    <img class='portrait' alt="" src="https://i.ibb.co/FwMkVsS/IMG-0872.jpg" />
                </div>
                <div>
                    <img class='landscape' alt="" src="https://i.ibb.co/DfQtKM3/IMG-3518.jpg" />
                </div>
            </Carousel>
            
            </div>
            <div id='visualize-right'></div>
        </div>)
}
export default visualize;

